import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import moment from 'moment'
import bowser from 'bowser'
import _ from 'lodash'

import { CONTACTS_CODES, DATA_BOX_PREFIX } from './constants'

import './style.scss'

const browser = bowser.getParser(typeof window !== 'undefined' ? window.navigator.userAgent : 'UA')

export default class Contacts extends Component {
    static propTypes = {
        data: PropTypes.array,
        translates: PropTypes.shape({
            phoneTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            faxTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            greenLineTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            dataBoxTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            emailTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            wwwTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    handleOpenWebPage = (webPage) => () => {
        window.open(webPage, '_blank')
    }

    handleOpenDataBox = (dataBoxCode) => () => {
        window.open(`${DATA_BOX_PREFIX}${dataBoxCode}`, '_blank')
    }

    formatData = (dataContainer) => {
        // filter empty of property data
        const filtered = _.filter(dataContainer, ({ data }) => !_.isEmpty(data))

        // sorted by order
        const sorted = _.sortBy(filtered, ['order'])

        // create array of tuples e.g. [1,2,3,4,5] => [[1,2],[3,4],[5]]
        return _.reduce(
            sorted,
            (container, value, index, collection) => {
                if (index % 2 === 0) return [...container, _.slice(collection, index, index + 2)]
                return container
            },
            []
        )
    }

    renderPhone = ({ value, date }, key) => (
        <div className={'block-contacts-content-row'} key={`block-contacts-content-phone-${key}`}>
            <a className={'block-contacts-row-item link'} href={`${browser.is('mobile') ? 'tel:' : 'skype:'}${value}`}>
                {value}
            </a>
            {date && this.renderDate(date)}
        </div>
    )

    renderWeb = ({ value, startDate }, key) => (
        <div className={'block-contacts-content-row'} key={`block-contacts-content-web-${key}`}>
            <div onClick={this.handleOpenWebPage(value)} className={'block-contacts-row-item link'}>
                {value}
            </div>
            {startDate && this.renderDate(startDate.value)}
        </div>
    )

    renderGreenLine = ({ value, startDate }, key) => (
        <div className={'block-contacts-content-row'} key={`block-contacts-content-green-line-${key}`}>
            <div className={cx('block-contacts-row-item')}>{value}</div>
            {startDate && this.renderDate(startDate.value)}
        </div>
    )

    renderDataBox = ({ value, startDate }, key) => (
        <div className={'block-contacts-content-row'} key={`block-contacts-content-data-box-${key}`}>
            <div className={'block-contacts-row-item link'} onClick={this.handleOpenDataBox(value)}>
                {value}
            </div>
            {startDate && this.renderDate(startDate.value)}
        </div>
    )

    renderEmail = ({ value, startDate }, key) => (
        <div className={'block-contacts-content-row'} key={`block-contacts-content-email-${key}`}>
            <a className={cx('block-contacts-row-item link')} href={`mailto:${value}`}>
                {value}
            </a>
            {startDate && this.renderDate(startDate.value)}
        </div>
    )

    renderFax = ({ value, startDate }, key) => (
        <div className={'block-contacts-content-row'} key={`block-contacts-content-fax-${key}`}>
            <div className={'block-contacts-row-item '}>{value}</div>
            {startDate && this.renderDate(startDate.value)}
        </div>
    )

    renderDate = (date) => (
        <div className={'block-contacts-row-item '}>
            {this.props.translates.from} {moment(date).format('D. M. YYYY')}
        </div>
    )

    render() {
        const { data } = this.props
        const { PHONE_CODE, FAX_CODE, WEB_CODE, EMAIL_CODE, GREEN_LINE_CODE, DATA_BOX_CODE } = CONTACTS_CODES

        if (!data) return null

        const formattedData = this.formatData(data)

        return (
            <div className={'block-contacts'}>
                {_.map(formattedData, (group, key) => (
                    <div className={'block-contacts-row'} key={`block-contacts-row-${key}`}>
                        {_.map(group, (groupItem, groupKey) => (
                            <div className={'block-contacts-item'} key={`block-contacts-item-${groupKey}`}>
                                <div className={cx('block-contacts-title', _.camelCase(groupItem.type))}>
                                    {this.props.translates[`${_.camelCase(groupItem.type)}Title`]}
                                </div>
                                <div className={'block-contacts-content'}>
                                    {_.map(groupItem.data, (item, itemKey) => {
                                        switch (groupItem.type) {
                                            case PHONE_CODE:
                                                return this.renderPhone(item, itemKey)
                                            case WEB_CODE:
                                                return this.renderWeb(item, itemKey)
                                            case GREEN_LINE_CODE:
                                                return this.renderGreenLine(item, itemKey)
                                            case DATA_BOX_CODE:
                                                return this.renderDataBox(item, itemKey)
                                            case EMAIL_CODE:
                                                return this.renderEmail(item, itemKey)
                                            case FAX_CODE:
                                                return this.renderFax(item, itemKey)
                                            default:
                                                return null
                                        }
                                    })}
                                </div>
                            </div>
                        ))}

                        {group.length === 1 && <div className={'block-contacts-item banner'} />}
                    </div>
                ))}
            </div>
        )
    }
}
